import React, { useEffect, useRef } from "react";

const Audio = ({ active, notify }) => {
    const audioRef = useRef(null);
    const timerRef = useRef(null);

    useEffect(() => {
        if (active) {
            const audio = audioRef.current;
            if (audio) {
                audio.play();
                timerRef.current = setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                    notify(false);
                }, 3000);
            }
        } else {
            // If active becomes false, stop the audio immediately
            const audio = audioRef.current;
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [active]);

    return (
        <div>
            <audio ref={audioRef} src="/notify.mp3" loop />
        </div>
    );
};

export default Audio;
